import { CommonModule } from '@angular/common';
// tslint:disable-next-line:max-line-length
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ContentChildren, Input, NgModule, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { ThemePalette } from '@angular/material/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconDefinition } from '@fortawesome/pro-light-svg-icons';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'to-sidetab',
  template: '<ng-template><ng-content></ng-content></ng-template>',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SideTabComponent {
  @Input() icon: IconDefinition;
  @Input() color: ThemePalette = 'accent';
  @Input() badge: number;
  @Input() badgeColor: ThemePalette = 'primary';
  index: number;
  @ViewChild(TemplateRef, { static: true }) content: TemplateRef<any>;
}

@Component({
  // tslint:disable-next-line:directive-selector
  selector: 'to-sidetab-content',
  template: '<ng-content></ng-content>',
})
export class SideTabContentComponent {
}

@Component({
  selector: 'to-sidetab-container',
  styleUrls: ['./sidetab.scss'],
  templateUrl: './sidetab-container.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideTabContainerComponent implements AfterViewInit, OnDestroy {

  @ViewChild('sidenav') public sidenav: any;
  @ContentChildren(SideTabComponent, { descendants: true }) sideTabs: any;

  protected _destroyed = new Subject<void>();

  sideNavView: number = null;
  sideTabsArray: any[];

  constructor(
    private changeRef: ChangeDetectorRef,
  ) { }

  ngAfterViewInit(): void {
    this.sideTabsArray = this.sideTabs.toArray();

    this.sideTabs.changes
      .pipe(takeUntil(this._destroyed))
      .subscribe(() => {
        this.sideTabsArray = this.sideTabs.toArray();
        this.changeRef.markForCheck();
      });
  }

  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
  }


  openSidenav(view: number) {
    if (this.sideNavView !== view) {
      this.sideNavView = view;
      this.sidenav.open();
    } else {
      this.sideNavView = null;
      this.sidenav.close();
    }
  }

  trackIndex(index: number) {
    return index;
  }

}

@NgModule({
  imports: [
    CommonModule,
    RouterModule,

    MatSidenavModule,
    MatButtonModule,
    MatBadgeModule,

    FontAwesomeModule,
  ],
  declarations: [
    SideTabContainerComponent,
    SideTabComponent,
    SideTabContentComponent,
  ],
  exports: [
    SideTabComponent,
    SideTabContainerComponent,
    SideTabContentComponent,
  ]
})
export class SideTabModule { }
